import _regeneratorRuntime from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/Adrian265431/viadeUO265431/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * A src property should be a valid LDflex expression,
 * but it can also be specified as a URL.
 * This function turns URLs into valid LDflex expressions,
 * which is useful if you want to manipulate expressions directly.
 */
export function srcToLDflex(src) {
  if (/^https?:[^"]+$/.test(src)) src = "[\"".concat(src, "\"]");
  return src;
}
/**
 * Returns an object with only the given keys from the source.
 */

export function pick(source, keys) {
  var destination = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;
      destination[key] = source[key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return destination;
}
/**
 * Determines the display name of a component
 * https://reactjs.org/docs/higher-order-components.html
 */

export function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}
/**
 * Creates a higher-order component with the given name.
 */

export function higherOrderComponent(name, createWrapper) {
  return function (Component) {
    var Wrapper = createWrapper(Component);
    Wrapper.displayName = "".concat(name, "(").concat(getDisplayName(Component), ")");
    return Wrapper;
  };
}
/**
 * Creates a task queue that enforces a minimum time between tasks.
 * Optionally, new tasks can cause any old ones to be dropped.
 */

export function createTaskQueue() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$drop = _ref.drop,
      drop = _ref$drop === void 0 ? false : _ref$drop,
      _ref$timeBetween = _ref.timeBetween,
      timeBetween = _ref$timeBetween === void 0 ? 10 : _ref$timeBetween,
      _ref$concurrent = _ref.concurrent,
      concurrent = _ref$concurrent === void 0 ? drop ? 1 : 4 : _ref$concurrent;

  var queue = [],
      scheduler = 0; // Runs all queued tasks, with the required minimum time in between

  function runQueuedTasks() {
    scheduler = queue.length && setTimeout(runQueuedTasks, timeBetween);
    queue.splice(0, concurrent).forEach(
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref2) {
        var run, resolve, reject;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                run = _ref2.run, resolve = _ref2.resolve, reject = _ref2.reject;
                _context.prev = 1;
                _context.t0 = resolve;
                _context.next = 5;
                return run();

              case 5:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t2 = _context["catch"](1);
                reject(_context.t2);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
  }

  return {
    /** Schedules the given task(s) */
    schedule: function schedule(functions) {
      var _queue;

      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // Schedule a single task
      if (!Array.isArray(functions)) return schedule([functions])[0]; // Create the tasks and their result promises

      var tasks = [];
      var results = functions.map(function (run) {
        return new Promise(function (resolve, reject) {
          return tasks.push({
            run: run,
            resolve: resolve,
            reject: reject,
            group: group
          });
        });
      }); // Schedule the tasks

      if (drop) queue = tasks;else (_queue = queue).push.apply(_queue, tasks);
      if (!scheduler) runQueuedTasks();
      return results;
    },

    /** Forgets pending tasks (optionally only those in a given group).
        Returns a boolean indicating whether there were any. */
    clear: function clear(group) {
      var hadPendingTasks = queue.length > 0;
      queue = queue.filter(function (task) {
        return group !== undefined && task.group !== group;
      });
      return hadPendingTasks;
    }
  };
}